import React, { FC } from "react";
import { Link } from "react-router-dom";
import FileSize from "../../../components/FileSize";
import { stripFileType } from "../../../utils";
import { getSearchPivotLink } from "../../samples/util";
import { LOCATION } from "../../search/consts";

type Props = {
  filename?: string;
  predictedFilename?: string;
  size?: number;
  fileType?: string;
  typeDescription?: string;
  fileFormat?: string;
  additionalContent?: React.ReactNode;
  location?: string;
};

const RlNavSummary: FC<Props> = ({
  filename,
  predictedFilename,
  size,
  fileType,
  typeDescription,
  fileFormat = "--",
  additionalContent,
  location = LOCATION.CLOUD
}) => (
  <div className="rl-nav__summary">
    <div
      className="rl-nav__summary-item rl-nav__summary-item--filename overflow-ellipsis"
      data-testid="sample_details_nav_summary_filename"
    >
      {filename}
    </div>
    <div className="rl-nav__summary-item-container">
      {predictedFilename && (
        <div
          className="rl-nav__summary-item"
          data-testid="sample_details_nav_summary_predicted_filename"
        >
          {predictedFilename}
        </div>
      )}
      <div
        className="rl-nav__summary-item"
        data-testid="sample_details_nav_summary_filesize"
      >
        Size: <FileSize value={size} />
      </div>
      <div
        className="rl-nav__summary-item"
        data-testid="sample_details_nav_summary_filetype"
      >
        Type:{" "}
        {fileType ? (
          <Link
            to={getSearchPivotLink(
              `filetype:"${stripFileType(fileType)}"`,
              {},
              false,
              location
            )}
            className="pivot-link"
            title={typeDescription}
            data-testid="sample_details_nav_summary_filetype_link"
          >
            {fileType}
          </Link>
        ) : (
          "--"
        )}
      </div>
      <div
        className="rl-nav__summary-item"
        data-testid="sample_details_nav_summary_format"
      >
        Format:{" "}
        {fileFormat ? (
          <Link
            to={getSearchPivotLink(
              `filetype:"${stripFileType(
                `${fileType}/${fileFormat.split(":")[0]}`
              )}"`,
              {},
              false,
              location
            )}
            className="pivot-link"
            data-testid="sample_details_nav_summary_format_link"
          >
            {fileFormat}
          </Link>
        ) : (
          "--"
        )}
      </div>
    </div>
    {additionalContent}
  </div>
);

export default RlNavSummary;
